<template>
  <!-- 富文本组件 -->
  <div id="wangeditor">
    <div ref="editorElem" style="text-align:left" :class="{ 'disabled': disabled }"></div>
  </div>
</template>
<script>
import E from 'wangeditor'
export default {
  props: ['catchData', 'value','content','rangenum', 'disabled'],    //接收父组件的方法
  name: 'editorElem',
  data () {
    return {
      editorContent: '',
      editor: null,
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  watch: {
    // value: function (value) {
    //   if (value !== this.editor.txt.html()) {
    //     // let regImg = new Reg("<img\b[^<>]*?\bsrc[\s\t\r\n]*=[\s\t\r\n]*[""']?[\s\t\r\n]*(?<imgUrl>[^\s\t\r\n""'<>]*)[^<>]*?/?[\s\t\r\n]*>", RegexOptions.IgnoreCase);

    //     this.editor.txt.html(value);
    //     this.catchData(value)  //把这个html通过catchData的方法传入父组件
    //   }
    // },
    content(value) {
        // console.log("没有光标则执行，有光标不执行，回显--解决输入时光标老跳到最底部", this.content, this.rangenum)
        if (null == this.rangenum) {
            // this.content.setRange(this.rangenum)
            this.editor.txt.html(this.content)
        }
    },
    disabled: {
      handler(newVal) {
        if (this.editor) {
          if (newVal) {
            // 禁用编辑器
            this.editor.$textElem.attr('contenteditable', false);
          } else {
            // 启用编辑器
            this.editor.$textElem.attr('contenteditable', true);
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 判断图片是否存在
    CheckImgExists (imgurl) {
      var ImgObj = new Image(); //判断图片是否存在
      ImgObj.src = imgurl;
      //存在图片
      if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted () {
    this.editor = new E(this.$refs.editorElem)        //创建富文本实例
    this.editor.customConfig.onchange = (value) => {
      this.editorContent = value
      this.catchData(value)  //把这个html通过catchData的方法传入父组件
    }
    this.editor.customConfig.uploadImgServer = this.$imgUploadApi;
    this.editor.customConfig.uploadFileName = 'img[]' //接口参数名
    // 最多一次上传20张
    this.editor.customConfig.uploadImgMaxLength = 20;
    this.editor.customConfig.uploadImgHeaders = {
      'Accept': '*/*',
      // 'Authorization': 'Bearer ' + token    //头部token
    }
    this.editor.customConfig.menus = [          //菜单配置
      'head',
      'list',  // 列表
      'justify',  // 对齐方式
      'bold',
      'fontSize',  // 字号
      'fontName',  // 字体
      'italic',
      'underline',
      'image',  // 插入图片
      'foreColor',  // 文字颜色
      'backColor',  // 背景颜色
      'link',  // 插入链接
      'undo',  // 撤销
      'redo',  // 重复
    ]
    let _this = this;
    // 配置字体
    this.editor.customConfig.fontNames = [
      '宋体',
      '黑体',
      '楷体',
      '仿宋',
      '微软雅黑',
      'Arial',
      'Tahoma',
      'Verdana'
    ];

    //下面是最重要的的方法
    this.editor.customConfig.uploadImgHooks = {
      before: function (xhr, editor, files) {
        // console.log(xhr, editor)
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function (xhr, editor, result) {
        // console.log(xhr, editor)
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果

        // this.imgUrl = '';
        // let resImgs = result.data;
        // if(Array.isArray(resImgs)){
        //   resImgs.forEach((img)=>{
        //     let path = _this.$url(img.path);
        //     this.imgUrl+=(Object.values(path).toString());
        //   })
        // }


      },
      fail: function (xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function (xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function (xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        let resImgs = result.data;
        if(Array.isArray(resImgs)){
          resImgs.forEach((img)=>{
            let url = _this.$url(img.path);
            insertImg(url)
          })
        }

        // let url = Object.values(data)      //result.data就是服务器返回的图片名字和链接
        // JSON.stringify(url)    //在这里转成JSON格式

        // result 必须是一个 JSON 格式字符串！！！否则报错
      }
    },
    this.editor.create()
    this.editor.txt.html(this.content);
    
    // 初始化时根据disabled属性设置编辑器状态
    if (this.disabled) {
      this.editor.$textElem.attr('contenteditable', false);
    }
  }
}
</script>
<style lang="less">
#wangeditor {
  transform: translateY(-14px);
  .w-e-toolbar {
    width: 900px;
    background-color: #ffffff !important;
  }
  .w-e-menu i {
    color: #081234;
  }
  .w-e-text-container {
    height: 520px !important;
  }
  .w-e-text img:hover {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  }
  
  &.disabled {
    .w-e-toolbar {
      pointer-events: none;
      opacity: 0.3;
    }
    .w-e-text-container {
      pointer-events: none;
      opacity: 0.7;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/wangeditor.vue